<template>
  <div>
    <p style="position: absolute;left: -999999px;">{{ changeInfoTemp }}</p>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-reserves'>{{translations('navbar.sale_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-reserves'>{{translations('navbar.archive_reserve')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('reserve.reserve_detail')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <div v-show="Number(ordersInfo.outsourcing_type) < 2 || Number(ordersInfo.outsourcing_type) === 3" class='form mb-3'><!-- 0:未登録, 1:通常販売, 2:委託販売, 3:任意 -->
            <v-row>
              <v-col class="d-flex align-center" cols="6" :sm="3">
                <template v-if="!isNeedApprove || isApproved">
                  <button class='btn btn-primary'
                          @click="openSingleReserveProcessModal()"
                          :disabled="((Number(ordersInfo.order_status) === OrderStatus.SHIPPED) || ordersInfo.destination_id == null || ordersInfo.destination_id === '' || disableButtonShip)"
                          type='button'>{{ translations('reserve.reserve_process') }}</button>
                  <button ref="openSingleReserveProcessModal"
                          hidden="true"
                          class='btn btn-primary'
                          type='button'
                          data-toggle='modal'
                          data-target='#SingleReservesModal'><i></i></button>
                </template>
                <template v-else-if="isNeedApprove && isNotRequestApprove" class='mb-4'>
                  <button class='btn btn-primary' @click="requestApprove">{{ translations('reserve.approval_app') }}</button>
                </template>
              </v-col>
              <v-col class="d-flex align-center" cols="6" :sm="3" v-if="Number(ordersInfo.order_status) !== OrderStatus.NOT_RESERVED">
                <template v-if="!isNeedApprove || isApproved">
                  <button class='btn btn-primary'
                          @click="openSingleReservesModal()"
                          :disabled="((Number(ordersInfo.order_status) === OrderStatus.SHIPPED) || ordersInfo.destination_id == null || ordersInfo.destination_id === '' || disableButtonShip)"
                          type='button'>{{ translations('reserve.shipping_process') }}</button>
                  <button ref="openSingleReservesModal"
                          hidden="true"
                          class='btn btn-primary'
                          type='button'
                          data-toggle='modal'
                          data-target='#SingleReservesModal'><i></i></button>
                </template>
                <template v-else-if="isNeedApprove && isNotRequestApprove" class='mb-4'>
                  <button class='btn btn-primary' @click="requestApprove">{{ translations('reserve.approval_app') }}</button>
                </template>
              </v-col>
              <v-col v-if="Number(ordersInfo.order_status) === OrderStatus.NOT_RESERVED || Number(ordersInfo.order_status) === OrderStatus.RESERVE_COMPLETED || Number(ordersInfo.order_status) === OrderStatus.RESERVE_COMPLETED_PARTIAL" class="d-flex align-center" cols="6" :sm="setValueSmOrder" >
                <template>
                  <button :disabled="tempInfo.division_type === 'B'" class='btn btn-info' @click="moveToOrder">{{ translations('reserve.process_order') }}</button>
                </template>
              </v-col>
              <v-col class="d-flex align-center" cols="6" :sm="setValueSmReturn">
                <button :disabled="!beforeId" class='btn btn-primary' @click="returnOn">{{translations('reserve.return')}}</button>
              </v-col>
              <v-col class="d-flex align-center" cols="6" sm="2">
                <button :disabled="!afterId" class='btn btn-primary' @click="moveOn">{{translations('reserve.move_on')}}</button>
              </v-col>
            </v-row>
            <div v-if="isNeedApprove && isNotRequestApprove" class='mb-4'>
              <small class="text-danger">{{translations('reserve.message_request_approve')}}</small>
            </div>
            <div v-if="isNeedApprove && !isNotRequestApprove && !isApproved" style="">
              <h6 class='mb-3 approval text-danger'>{{translations('reserve.message_request_approve')}}</h6>
              <table class='table table-sm table-borderless table-information'>
                <tbody>
                  <tr v-for="(user, i) in approveUsers" :key="i">
                    <th>{{ user.name }}</th>
                    <td v-if="isUserApproved(user)"><span class="text-primary padding-left-8">{{translations('reserve.approved')}}</span></td>
                    <td v-else-if="isApproveRole(user)"><button type='button' class='btn btn-primary btn-sm' @click="approve(user)">{{translations('reserve.approve')}}</button></td>
                    <td v-else><span class="text-danger padding-left-8">{{translations('reserve.unapproved')}}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{ translations('order.order_status') }}</th>
                <td>
                  <span class="badge" :class="getStatusClass(ordersInfo.order_status)">
                    {{ getStatusLabel(ordersInfo.order_status) }}
                  </span>
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.registration_date') }}</th>
                <td v-show="(Number(ordersInfo.order_status) === OrderStatus.NOT_RESERVED)">
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '--------------' }}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('reserve.registration_date') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model="tempInfo.ordered_at" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('ordered_at', tempInfo.ordered_at, 'info01')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="(Number(ordersInfo.order_status) !== OrderStatus.NOT_RESERVED)">{{$invoiceTools.formatDateAt(ordersInfo.ordered_at)}}</td>
              </tr>
              <tr>
                <th>{{ translations('reserve.division') }}</th>
                <td>{{ translations('reserve.reservation') }}</td>
              </tr>
              <tr>
                <th>{{ translations('reserve.order_number') }}</th>
                <td>{{ordersInfo.order_number}}</td>
              </tr>
              <tr>
                <th>{{ translations('sale.reserve_number') }}</th>
                <td>{{ordersInfo.reserve_number ? ordersInfo.reserve_number : '-'}}</td>
              </tr>
              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{ translations('reserve.bill_to') }}</th>
                <td v-show="(!ordersInfo.estimate_id) && (Number(ordersInfo.order_status) === OrderStatus.NOT_RESERVED)">
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ ordersInfo.client && ordersInfo.client.name ? ordersInfo.client.name : '--------------' }}</button>
                  <div v-if="billings" ref="popover-info04" id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('reserve.bill_to') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <p style="position:absolute;left:-10000px">{{forcechange}}</p>
                      <v-select :options="billings" label="name" v-model="tempInfo.client" @input="setSelectedClient"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('client_id', tempInfo.client, 'info04')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="ordersInfo.estimate_id || (Number(ordersInfo.order_status) !== OrderStatus.NOT_RESERVED)">{{ ordersInfo.client_name }}</td>
              </tr>

              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{ translations('reserve.destination_name') }}</th>
                <td v-if="[OrderStatus.NOT_RESERVED, OrderStatus.RESERVE_COMPLETED].includes(Number(ordersInfo.order_status))"><!-- 未出荷 -->
                    <button ref="info05" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info05' data-placement='right'>{{ ordersInfo.destination_name || '--------------' }}</button>
                    <div ref="popover-info05" id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('reserve.destination_name') }}</div>
                        <div class='popover-body popover-content'>
                          <v-select :options="destinations" label="name" v-model="tempInfo.destination" @input="setSelectedDestination"></v-select>
                        </div>
                        <div class='popover-footer'>
                        <button type='submit'  v-on:click="updateField('destination_id', tempInfo.destination.id, 'info05')" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                        </div>
                    </div>
                </td>
                <td v-else>{{ ordersInfo.destination_name }}</td>
              </tr>
              <tr v-show="ordersInfo.division_type !== 'B'">
                <th>{{ translations('reserve.contact_person') }}</th>
                <td v-show="!(Number(ordersInfo.order_status) !== OrderStatus.NOT_RESERVED)">
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ ordersInfo.end_user || '--------------' }}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('reserve.contact_person') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.end_user" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('end_user', tempInfo.end_user, 'info06')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="(Number(ordersInfo.order_status) !== OrderStatus.NOT_RESERVED)">{{ordersInfo.end_user}}</td>
              </tr>
              <tr v-show="ordersInfo.division_type === 'B'">
                <th>{{ translations('reserve.contact_person') }}</th>
                <td>
                  <button
                    ref='info006'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info006'
                    data-placement='right'
                  >
                  {{ ordersInfo.users_in_charge ? ordersInfo.users_in_charge['user_name'] : '-----------' }}
                  </button>
                  <div id='popover-info006' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('reserve.contact_person') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="usersList" label="user_name" value="id" v-model="tempInfo.users_in_charge"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('users_in_charge', tempInfo.users_in_charge, 'info006')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.slip_number_dedicated_code') }}</th>
                <td>
                  <div class="d-flex">
                    <input
                      v-model="slipNumber"
                      type="text"
                      class="form-control form-control-sm mr-1"/>
                    <input
                      v-model="cdItem"
                      type="text"
                      class="form-control form-control-sm w-75"/>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.temporary_direct_transmission') }}</th>
                <td>
                  <input v-model="isTempShipping" type="checkbox" @change="changeTempShipping">
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.company_name') }}</th>
                <td>
                  <input
                  v-model="tempInfo.company_name_temp"
                  type="text"
                  class="form-control form-control-sm"
                  :class="{'text-transparent': !isTempShipping}"
                  :disabled="!isTempShipping"/>
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.place_delivery') }}</th>
                <td>
                  <textarea
                  v-model="tempInfo.destination_name_temp"
                  type=""
                  class="form-control form-control-sm min-height-120"
                  :class="{'text-transparent': !isTempShipping}"
                  :disabled="!isTempShipping"/>
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.supplier') }}</th>
                <td>
                  <textarea
                    v-model="tempInfo.suppliers_temp"
                    type="text"
                    class="form-control form-control-sm min-height-120"
                    :class="{'text-transparent': !isTempShipping}"
                    :disabled="!isTempShipping"/>
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.remarks') }}</th>
                <td>
                  <input
                    v-model="tempInfo.note_temp"
                    type="text"
                    class="form-control form-control-sm"
                    :class="{'text-transparent': !isTempShipping}"
                    :disabled="!isTempShipping"/>
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.amount') }}</th>
                <td>
                  <input
                    v-if="isTempShipping"
                    v-model="tempInfo.remove_price_temp"
                    type="checkbox"/>
                  <input
                    v-else
                    type="checkbox"
                    disabled />
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.remarks') }}</th>
                <td v-if="[OrderStatus.NOT_RESERVED, OrderStatus.RESERVE_COMPLETED].includes(Number(ordersInfo.order_status))">
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ ordersInfo.memo || '--------------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('reserve.remarks') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info07')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="![OrderStatus.NOT_RESERVED, OrderStatus.RESERVE_COMPLETED].includes(Number(ordersInfo.order_status))">
                  {{ordersInfo.memo}}
                </td>
              </tr>
              <tr>
                <th>{{ translations('reserve.internal_memo') }}</th>
                <td v-if="[OrderStatus.NOT_RESERVED, OrderStatus.RESERVE_COMPLETED].includes(Number(ordersInfo.order_status))">
                <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0 btn-memo-internal'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                    style="white-space: pre-line"
                  >{{ ordersInfo.note || '--------------' }}</button>
                  <div id='popover-info08' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('reserve.internal_memo') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <textarea type='text' v-model.trim="tempInfo.note" class='form-control' maxlength="300" />
                    </div>
                    <div class='popover-footer d-flex justify-content-between'>
                      <button type="button" class="btn btn-sm btn-secondary" @click="closeModal('info08')">{{translations('common.close')}}</button>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('note', tempInfo.note, 'info08')">{{translations('common.keep')}}</button>
                    </div>
                  </div>
                </td>
                <td v-show="![OrderStatus.NOT_RESERVED, OrderStatus.RESERVE_COMPLETED].includes(Number(ordersInfo.order_status))">
                  {{ordersInfo.note}}
                </td>
              </tr>
              <tr>
                <th>{{ translations('common.last_updated_by') }}</th>
                <td>{{ordersInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{ translations('common.last_update_time') }}</th>
                <td>{{ordersInfo.updated_at}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <h5>Files</h5>
          <div class="card" :class="(poFile == null) ? 'hidden' : ''">
            <ul class="list-group list-group-flush">
              <li class="list-group-item list-group-item-info d-flex justify-content-between"><a @click="openPdf()">{{ translations('reserve.purchase_order') }}<i class="fas fa-external-link-alt"></i></a><button type="button" class="btn btn-link p-0 mr-1" @click="poFile = null"><i class="far fa-times-circle"></i></button></li>
            </ul>
          </div>
          <div class="card" :class="(poFile == null) ? '' : 'hidden'">
            <ul class="list-group list-group-flush">
              <li class="list-group-item"><button class="btn btn-link p-0" type="button" data-toggle="modal" data-target="#NewOrdersFileModal">{{ translations('reserve.purchase_order') }}<i class="fas fa-paperclip"></i></button></li>
            </ul>
          </div>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteReserves()" data-href='#'>{{ translations('common.delete') }}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1100'>
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <input :checked="allChecked"
                           type="checkbox"
                           @change="onChangeCheckedAll"/>
                  </th>
                  <th></th>
                  <th>{{translations('reserve.commodity_condition')}}</th>
                  <th>{{translations('reserve.line_number')}}</th>
                  <th>{{translations('reserve.jan_code')}}</th>
                  <th>{{translations('reserve.model')}}</th>
                  <th>{{translations('reserve.product_abbreviation_name')}}</th>
                  <th>{{translations('reserve.tax_classification')}}</th><!-- TAXSTATUS -->
                  <th>{{translations('reserve.reserve_quantity')}}</th>
                  <th>{{translations('reserve.number_shipments')}}</th>
                  <th>{{translations('reserve.number_reserved')}}</th>
                  <th>{{translations('reserve.unit_price')}}</th>
                  <th>{{translations('reserve.product_cost')}}</th>
                  <th>{{translations('reserve.client_order_number')}}</th>
                  <th>{{translations('reserve.summary')}}</th>
                  <th>{{translations('reserve.product_internal_memo')}}</th>
                  <th>{{translations('reserve.unit_price_total')}}</th>
                  <th>{{translations('reserve.total_cost')}}</th>
                  <th>{{translations('reserve.total_profit')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(detail, i) in ordersDetails">
                  <tr :key="i">
                    <td>
                      <button v-if="(Number(ordersInfo.order_status) === OrderStatus.NOT_RESERVED) " tabindex="-1" @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td v-if="detail.reserved != 2">
                      <input for="checkBox"
                             type="checkbox"
                             :checked="detail.check"
                             :value="detail.id"
                             @change="onChangeInputChecked"/>
                    </td>
                    <td v-else></td>
                    <td v-if ="detail.reserved == 2" colspan="1">
                      <span class="badge badge-danger">
                        {{ translations('reserve.status_shipped') }}
                      </span>
                    </td>
                    <td v-else-if ="detail.reserved == 4" colspan="1">
                      <span class="badge badge-dark">
                        {{ translations('reserve.reserve_completed') }}
                      </span>
                    </td>
                    <td v-else-if="detail.reserved == 5" colspan="1">
                      <span class="badge badge-warning">
                        {{ translations('reserve.reserve_completed_partial') }}
                      </span>
                    </td>
                    <td v-else-if ="detail.reserved == 6" colspan="1">
                      <span class="badge badge-warning">
                        {{ translations('reserve.partial_shipment') }}
                      </span>
                    </td>
                    <td v-else></td>
                    <td>{{ Number(detail.is_outlet) ? translations('order.outlet') : Number(detail.is_bad) ? translations('order.bad') : translations('order.good') }}</td>
                    <td>{{ i + 1 }}</td>
                    <td>{{ detail.jan_code }}</td>
                    <td>{{ detail.type_number }}</td>
                    <td class="right"><input :readonly="(Number(ordersInfo.order_status) === OrderStatus.SHIPPED)" type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.omission_name" :title="detail.omission_name"></td>
                    <td v-if="Number(ordersInfo.order_status) === OrderStatus.NOT_SHIPPED">
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onChangeUnitPrice(detail)">
                        <option value="1">{{translations('order.taxable_item')}}</option>
                        <option value="2">{{translations('order.not_applicable')}}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <td v-else>{{ Number(detail.taxclass_id) === 1 ? translations('order.taxable_item') : translations('order.not_applicable') }}</td>
                    <td style="min-width:80px;"><input type="text" @input="numbers(i,'quantity')" class="form-control form-control-sm" style="width:4em;" v-on:keyup="quantityKeyUp($event,detail)" v-model="detail.quantity" :readonly="detail.reserved == 2"/></td>
                    <td>{{ detail.total_quantity_shipped }}</td>
                    <td style="min-width:80px;"><input type="text" @input="numbers(i,'quantity')" class="form-control form-control-sm" style="width:4em;" v-on:keyup="quantityReservedKeyUp($event,detail)" v-model="detail.total_quantity_reserved" :disabled="detail.total_quantity_reserved === 0"/></td>
                    <template v-if="Number(ordersInfo.order_status) === 1">
                      <td style="min-width:80px;">
                        <div v-if="!taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                          <input type="text" @input="numbers(i,'unit_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" @change="onChangeUnitPrice(detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                          <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                        </div>
                        <div v-if="taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                          <input type="text" @input="numbers(i,'unit_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price_inctax" @change="onChangeUnitPrice(detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                          <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price_inctax && detail.unit_price_inctax.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                        </div>
                      </td>
                    </template>
                    <template v-else>
                      <td style="min-width:80px;">
                        <div v-if="!taxIncluded">{{ Number(detail.unit_price).toLocaleString() }}</div>
                        <div v-else>{{ Number(detail.unit_price_inctax).toLocaleString() }}</div>
                      </td>
                    </template>

                    <td class="right"><input :readonly="true" type="text" @input="numbers(i,'row_price')" class="form-control form-control-sm" style="width:6em;" v-model="detail.row_price"/></td>
                    <td class="right"><input :readonly="(Number(ordersInfo.order_status) === OrderStatus.SHIPPED) && !isCostco" type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.client_order_number"/></td>
                    <td class="right"><input :readonly="(Number(ordersInfo.order_status) === OrderStatus.SHIPPED)" type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks"/></td>
                    <td class="right">
                      <textarea
                        :readonly="Number(ordersInfo.order_status) === OrderStatus.SHIPPED"
                        class="form-control form-control-sm"
                        v-model="detail.internal_memo"
                        :rows="calculateRows(detail.internal_memo)"
                        :style="{minHeight: '28px'}"
                      ></textarea>
                    </td>
                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_profit') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                  </td>
                  <td colspan="1" v-if="Number(ordersInfo.order_status) === OrderStatus.PARTIAL_RESERVE"></td>
                  <td colspan="16"></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalCost, grandTotalCostIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalProfit, grandTotalProfitIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary mr-3' @click="updateReserves()">{{translations('common.update')}}</button>
            </div>
            <!-- outsourcingType 0:未登録, 1:通常販売, 2:委託販売 -->
            <div v-show="Number(outsourcingType) === 2 && Number(ordersInfo.order_status) === OrderStatus.SHIPPED"><!-- order_status 1:未出荷, 2:出荷済, 3:一部出荷 -->
              <a class="btn btn-link btn-sm decoration-underline" href="#" @click="openConsignmentSlip()">委託伝票出力<i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OrdersDetailsModal :details="ordersDetails" :ordersInfo="ordersInfo" :clients_id="tempInfo.client_id" :tax="{taxIncluded:taxIncluded, taxRate:taxRate}"/><!-- VAT -->

    <SingleReservesModal :warehouseRedFlag="warehouses" :ordersInfo="ordersInfo" :orderID="ordersID" :orderStatus = "orderStatus" :reserveDetails = 'reserveDetails' :shippingReserve = 'shippingReserve'/>
    <SingleConsignmentOrdersModal :orderID="ordersID" :outsourcing-type="outsourcingType"/>
    <NewOrdersFileModal :poFile="poFile"/>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import OrdersDetailsModal from '@/components/OrdersDetailsModal'
import SingleReservesModal from '@/components/SingleReservesModal'
import SingleConsignmentOrdersModal from '@/components/SingleConsignmentOrdersModal'
import NewOrdersFileModal from '@/components/NewOrdersFileModal'
import { DivisionType, OrderStatus } from '../constants'
import _ from 'lodash'
import { mapState } from 'vuex'

const UPDATE_TYPE_NORMAL = 0
const UPDATE_TYPE_INFORMATION = 1
const UPDATE_TYPE_REQUEST_APPROVE = 2
const UPDATE_TYPE_APPROVE = 3

const UNIQ_ADDRESS =
  `株式会社ユニーク
  〒277-0005
  千葉県柏市柏6-4-24 柏ビルディング2A
  TEL 04-7128-6556 FAX 04-7128-6557`

export default {
  name: 'SingleReserves',
  props: {},
  components: {
    VueElementLoading,
    OrdersDetailsModal,
    SingleReservesModal,
    SingleConsignmentOrdersModal,
    NewOrdersFileModal
  },

  data () {
    return {
      disableButtonShip: false,
      changeInfoTemp: 1,
      outsourcingType: 0,
      taxRate: 0, // VAT
      taxIncluded: false, // VAT
      department: '',
      ordersID: 0,
      destinations: [],
      ordersInfo: {},
      ordersDetails: [],
      tempInfo: {},
      slipNumber: '',
      cdItem: '',
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalCost: 0,
      grandTotalCostIncTax: 0,
      grandTotalProfit: 0,
      grandTotalProfitIncTax: 0,
      isLoading: true,
      isTempShipping: false,
      isUpdateContact: false,
      poFile: null,
      deliveryFile: null,
      consignmentFile: null,
      beforeId: null,
      afterId: null,
      objectURLs: [],
      DivisionType: DivisionType,
      warehouses: [],
      usersList: [],
      loadDivisionType: null,
      saleOrderId: [],
      forcechange: false,
      orderStatus: '',
      inputRows: 1,
      allChecked: false,
      isCheckDisable: true,
      reserveDetails: [],
      shippingReserve: false,
      OrderStatus: OrderStatus
    }
  },

  watch: {
    ordersDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })

        this.ordersDetails = v
        this.calcGrandTotals()
      },
      deep: true
    },
    'tempInfo.client_id': {
      handler: function (v, oldV) {
        const cname = this.getInfoClient(v)
        this.ordersInfo.client.name = cname
        if (oldV && this.tempInfo.division_type_select !== 'B') {
          this.ordersInfo.destination_name = ''
          this.ordersInfo.destination_id = '0'
          this.getEmployeeByCompany()
        }
        this.listDestinations()
      },
      deep: true
    }
  },

  created () {
    if (!this.$route.query.orders_id) {
      this.$router.replace('archive-orders')
    }
    this.listWarehouses()
    this.listUsers()
    this.isLoading = true
    this.ordersID = Number(this.$route.query.orders_id)
    this.$store.dispatch('Master/checkBillTo')

    Promise.all([
      this.getOrders(),
      this.getPoFile()
    ]).then(() => {
      this.popoverButtons()
      if (this.isUpdateContact) {
        this.updateField('end_user', this.tempInfo.end_user, 'info06')
        this.isUpdateContact = false
      }
    }).finally(() => {
      this.isLoading = false
    })
  },
  beforeDestroy () {
    this.objectURLs.forEach(objectURL => {
      URL.revokeObjectURL(objectURL)
    })
  },

  computed: {
    ...mapState(['currentLanguage']),
    billings () {
      return this.$store.getters['Master/getBillTo']
    },
    isApproved () {
      return Number(this.ordersInfo.approval_status) === 2
    },
    isNotRequestApprove () {
      return Number(this.ordersInfo.approval_status) === 0
    },
    isNeedApprove () {
      return !!this.ordersInfo.credit_quantity && (this.grandTotalUnitPrice >= this.ordersInfo.credit_quantity && this.grandTotalUnitPrice > 0) // BUGFIX 合計０の時は認証チェック不要
      // return false // STAGING DEBUG
    },
    approveUsers () {
      return this.ordersInfo.need_approvers ? JSON.parse(this.ordersInfo.need_approvers) : []
    },
    isPrintNeba () {
      return Number(this.outsourcingType) !== 2 && (Number(this.ordersInfo.order_status) === 2 || Number(this.ordersInfo.order_status) === 5)
    },
    isCostco () {
      return this.department === 'コストコ'
    },
    isShowPrintNeba () {
      if (this.isCostco) return true
      if (this.isPrintNeba && (!this.isNeedApprove || this.isApproved)) return true
      return false
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    },
    setValueSmOrder () {
      if (this.currentLanguage === 'en' && (Number(this.ordersInfo.order_status) === OrderStatus.NOT_RESERVED ||
        Number(this.ordersInfo.order_status) === OrderStatus.RESERVE_COMPLETED)) {
        return 6
      } else {
        return 4
      }
    },
    setValueSmReserve () {
      if (this.currentLanguage === 'en' && (Number(this.ordersInfo.order_status) === OrderStatus.NOT_RESERVED ||
        Number(this.ordersInfo.order_status) === OrderStatus.RESERVE_COMPLETED)) {
        return 3
      } else if (this.currentLanguage !== 'en' && (Number(this.ordersInfo.order_status) !== OrderStatus.PARTIAL_RESERVE)) {
        return 3
      }
    },
    setValueSmReturn () {
      if (this.currentLanguage === 'en') {
        return 3
      } else {
        if (Number(this.ordersInfo.order_status) === OrderStatus.RESERVE_COMPLETED_PARTIAL || Number(this.ordersInfo.order_status) === OrderStatus.RESERVE_COMPLETED) {
          return 3
        } else {
          return 2
        }
      }
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    setSelectedClient (value) {
      this.forcechange = !this.forcechange
      this.tempInfo.client = value
    },
    setSelectedDestination (value) {
      this.forcechange = !this.forcechange
      this.tempInfo.destination = value
    },
    quantityKeyUp (event, detail) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      detail.quantity = value
    },
    quantityReservedKeyUp (event, detail) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      detail.total_quantity_reserved = value
    },
    async listUsers () {
      try {
        let { data } = await this.$http.post(this.$api_url.account_user_list)
        if (data.status === true) {
          this.usersList = data.list
        } else {
          this.usersList = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        this.$toastr.error(this.translations('reserve.notice_failed'), this.translations('common.error'))
      }
    },
    async listWarehouses () {
      try {
        let { data } = await this.$http.post(`${this.$api_url.warehouse_list}?typeB=true`)
        if (data.status === true) {
          this.warehouses = data.list
        } else {
          this.warehouses = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        this.$toastr.error(this.translations('reserve.notice_failed'), this.translations('common.error'))
      }
    },
    numbers (index, target) {
      this.ordersDetails[index][target] = this.ordersDetails[index][target].toString().replace(/[^0-9.-]/g, '')
    },
    async listDestinations () {
      try {
        let cList = await this.$http.post(
          this.$api_url.destinations_list,
          { clients_id: this.tempInfo.client_id }
        )
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'SingleOrders:listDestinations')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('SingleOrders:listDestinations:catch(error): ', error)
        this.$toastr.error(this.translations('reserve.notice_failed'), this.translations('common.error'))
      }
    },
    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()}`
      } else {
        return `${Number(valIncTax).toLocaleString()}`
      }
    },
    toTaxFormat (data, key) {
      if (this.taxIncluded) {
        key = key + '_inctax'
      }
      const price = data[key] || 0
      return Number(price).toLocaleString()
    },

    prepareDetails (data, hasCost = false) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_profit = data.total_unit_price - data.total_cost

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
        data.total_profit_inctax = data.total_profit
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = data.quantity * data.unit_price_inctax
        data.total_profit_inctax = data.total_unit_price_inctax - data.total_cost_inctax
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0
      this.grandTotalCost = 0
      this.grandTotalCostIncTax = 0
      this.grandTotalProfit = 0
      this.grandTotalProfitIncTax = 0

      this.ordersDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        this.grandTotalCost += Number(v.total_cost)
        this.grandTotalUnitPriceIncTax += Number(v.total_unit_price_inctax)
      })

      this.grandTotalProfit = this.grandTotalUnitPrice - this.grandTotalCost

      this.grandTotalCostIncTax = this.$util.getIncludeTax(this.grandTotalCost, this.taxRate)
      this.grandTotalProfitIncTax = this.grandTotalUnitPriceIncTax - this.grandTotalCostIncTax
    },

    getOrders () {
      return this.$http.post(this.$api_url.reserves_detail, { orders_id: this.ordersID, reserve: true }).then(response => {
        let result = response.data
        if (result.status === true) {
          this.ordersInfo = result.information
          let details = result.details.map(function (elem) {
            elem.check = false
            return elem
          })
          this.ordersDetails = details
          this.saleOrderId = result.sale_order_id
          this.tempInfo = result.information
          this.orderStatus = result.information.order_status
          this.tempInfo.client = {
            id: this.tempInfo.client_id,
            name: this.tempInfo.client_name
          }
          this.tempInfo.division_type_select = result.information.division_type
          this.tempInfo.destination = {
            id: this.tempInfo.destination_id,
            name: this.tempInfo.destination_name
          }
          this.cdItem = this.tempInfo.cd_item
          this.slipNumber = this.tempInfo.slip_number
          this.tempInfo.ordered_at = this.$invoiceTools.formatDateAt(result.information.ordered_at, 1)
          this.isTempShipping = Boolean(Number(this.tempInfo.is_send_temp))
          if (this.isTempShipping) this.changeTempShipping()
          this.taxRate = result.information.tax_rate
          this.taxIncluded = result.information.tax_included
          this.outsourcingType = result.information.outsourcing_type
          if (result.information.division_type === 'B') {
            let indexWareHouse = _.findIndex(this.warehouses, function (o) { return o.id === parseInt(result.information.warehouse_id) })
            this.tempInfo.warehouse_id = this.warehouses[indexWareHouse]
            this.ordersInfo.warehouse_address = this.warehouses[indexWareHouse].name

            let indexWareHouseFrom = _.findIndex(this.warehouses, function (o) { return o.id === parseInt(result.information.warehouse_id_from) })
            this.tempInfo.warehouse_id_from = this.warehouses[indexWareHouseFrom]
            this.ordersInfo.warehouse_address_from = this.warehouses[indexWareHouseFrom].name

            let indexUserCharge = _.findIndex(this.usersList, function (o) { return parseInt(o.id) === parseInt(result.information.users_in_charge) })
            this.tempInfo.users_in_charge = this.usersList[indexUserCharge]
            this.ordersInfo.users_in_charge = this.usersList[indexUserCharge]
          }
          this.loadDivisionType = result.information.division_type

          // 前後のレコードを取得する
          if (result.before_id.length) {
            this.beforeId = result.before_id[0].id
          }
          if (result.after_id.length) {
            this.afterId = result.after_id[0].id
          }
          if (!this.tempInfo.end_user && this.tempInfo.end_user !== '') {
            this.getEmployeeByCompany()
          } else {
            this.isUpdateContact = true
          }
          return Promise.resolve()
        } else {
          this.$toastr.error(result.message)
          this.$router.push('/archive-reserves')
        }
      }).catch(error => {
        console.log('SingleOrders:getOrders:catch(error): ', error)
        return Promise.reject(new Error(this.translations('reserve.notice_failed')))
      })
    },

    // 発注書
    getPoFile () {
      return this.$http.post(this.$api_url.orders_po_file, { orders_id: this.ordersID }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.poFile = result.po_file || null
          return Promise.resolve()
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(error => {
        console.log('SingleOrders:getPoFile:catch(error): ', error)
        return Promise.reject(new Error(this.translations('reserve.notice_failed')))
      })
    },

    // 発注書
    openPdf () {
      if (this.poFile != null) {
        let arrBuff = this.__b64ToArrayBuffer(this.poFile.replace('data:application/pdf;base64,', ''))
        const pdfFile = new Blob([arrBuff], { type: 'application/pdf' })
        const pdfFileURL = URL.createObjectURL(pdfFile)
        window.open(pdfFileURL)
      }
    },

    // 委託納品伝票
    openConsignmentSlip () {
      this.isLoading = true
      return this.$http.post(this.$api_url.orders_consignment_slip, { orders_id: this.ordersID }).then(response => {
        const result = response.data
        if (result.status === true && result.slip) {
          let arrBuff = this.__b64ToArrayBuffer(result.slip.replace('data:application/pdf;base64,', ''))
          const consignmentFile = new Blob([arrBuff], { type: 'application/pdf' })
          const consignmentFileURL = URL.createObjectURL(consignmentFile)
          window.open(consignmentFileURL)
        } else {
          console.log('SingleOrders:openConsignmentSlip:status=false: ', result.message)
        }
      }).catch(error => {
        console.log('SingleOrders:openConsignmentSlip:catch(error): ', error)
        this.$toastr.error(this.translations('reserve.notice_failed'))
      }).finally(() => {
        this.isLoading = false
      })
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },
    getInfoClient (id) {
      const infoClient = this.billings.find(bill => bill.id === parseInt(id))
      if (infoClient) {
        this.taxIncluded = Number(infoClient.taxstatus) === 2
        this.department = infoClient.department
        return infoClient.name
      }
      return ''
    },

    /**
     * @param field : orders information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'ordered_at') {
          $this.$refs[ref].innerText = '--------------'
        } else {
          $this.$refs[ref].innerText = '--------------'
        }
        val = ''
      } else if (field === 'client_id') {
        this.billings.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
            $this.outsourcingType = v.outsourcingstatus // 委託先向けのUI切替 (0:非該当, 1:該当, 2:任意)
            $this.taxIncluded = Number(v.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
          }
        })
      } else if (field === 'destination_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.destinations.forEach(function (v) {
          if (v.id === parseInt(value)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'ordered_at') {
        const x = /-/gi
        $this.$refs[ref].innerText = value.replace(x, '/')
        val = value.replace(x, '/')
      } else if (field === 'warehouse_id') {
        this.disableButtonShip = true
        this.ordersInfo['warehouse_address'] = value.name
        $this.$refs[ref].innerText = this.ordersInfo['warehouse_address']
        this.ordersInfo[field] = value.id
        val = value
      } else if (field === 'warehouse_id_from') {
        this.disableButtonShip = true
        this.ordersInfo['warehouse_address_from'] = value.name
        $this.$refs[ref].innerText = this.ordersInfo['warehouse_address_from']
        this.ordersInfo[field] = value.id
        val = value
      } else if (field === 'users_in_charge') {
        this.ordersInfo['users_in_charge'] = value.user_name
        $this.$refs[ref].innerText = this.ordersInfo['users_in_charge']
        this.ordersInfo[field] = value.id
        val = value
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.ordersInfo[field] = val
      this.changeInfoTemp = this.changeInfoTemp + 1
      window.$('#popover-' + ref).popoverX('hide')
    },

    closeModal (ref) {
      if (ref) window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.ordersDetails.splice(i, 1)
    },

    updateReserves (updateType, user) {
      if (!this.ordersInfo.ordered_at) {
        this.$toastr.warning(this.translations('reserve.notice_enter_registration_date'))
        return
      }

      if (!this.ordersInfo.order_number) {
        this.$toastr.warning(this.translations('reserve.notice_order_number'))
        return
      }

      if (!this.ordersInfo.client_id) {
        this.$toastr.warning(this.translations('reserve.notice_shipping_address'))
        return
      }
      if (this.ordersDetails.length === 0) {
        this.$toastr.warning(this.translations('reserve.notice_enter_details_line'))
        return
      }

      let checkQuantityReserved = this.ordersDetails.some(product => product.total_quantity_reserved > (product.quantity - product.total_quantity_shipped))

      if (checkQuantityReserved) {
        this.$toastr.warning(this.translations('reserve.notice_quantity_out_of_reserve'))
        return
      }

      let confirmMessage = ''
      let successMessage = ''
      let errorMessage = ''
      if (!updateType || updateType === UPDATE_TYPE_NORMAL) {
        confirmMessage = this.translations('reserve.update_reserve')
        successMessage = this.translations('reserve.notice_reserve_update_success')
        errorMessage = this.translations('reserve.notice_reserve_update_fail')
      } else if (updateType === UPDATE_TYPE_INFORMATION) {
        confirmMessage = this.translations('reserve.notice_update_reserve_information')
        successMessage = this.translations('reserve.notice_update_reserve_information_success')
        errorMessage = this.translations('reserve.notice_update_reserve_information_fail')
      } else if (updateType === UPDATE_TYPE_REQUEST_APPROVE) {
        confirmMessage = this.translations('reserve.notice_request_approval')
        successMessage = this.translations('reserve.notice_request_approval_success')
        errorMessage = this.translations('reserve.notice_request_approval_fail')
      } else if (updateType === UPDATE_TYPE_APPROVE) {
        confirmMessage = this.translations('reserve.notice_over_credit_limit')
        successMessage = this.translations('reserve.notice_over_credit_limit_approved')
        errorMessage = this.translations('reserve.notice_over_credit_limit_fail')
      }

      this.$dialog.confirm(confirmMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        try {
          this.isLoading = true

          const ordersInfo = JSON.parse(JSON.stringify(this.ordersInfo))

          if (this.poFile != null) {
            ordersInfo.purchase_order_file = this.poFile
          } else {
            ordersInfo.purchase_order_file = ''
          }

          if (updateType === UPDATE_TYPE_REQUEST_APPROVE) {
            ordersInfo.approval_status = 1 // 承認依頼中
          } else if (updateType === UPDATE_TYPE_APPROVE && user) {
            const approvers = JSON.parse(ordersInfo.approvers)
            if (approvers.indexOf(user.id) < 0) {
              approvers.push(user.id)
            }
            let allOk = true
            for (let i = 0; i < this.approveUsers.length; i++) {
              const needUser = this.approveUsers[i]
              if (approvers.indexOf(needUser.id) < 0) {
                allOk = false
              }
            }
            if (allOk) {
              ordersInfo.approval_status = 2 // 承認済
            }
            ordersInfo.approvers = JSON.stringify(approvers)
          }

          ordersInfo.is_send_temp = this.isTempShipping
          if (!this.isTempShipping) {
            ordersInfo.company_name_temp = ''
            ordersInfo.suppliers_temp = ''
            ordersInfo.remove_price_temp = false
            ordersInfo.destination_name_temp = ''
            ordersInfo.note_temp = ''
          }

          ordersInfo.slip_number = this.slipNumber
          ordersInfo.cd_item = this.cdItem
          if (ordersInfo.division_type === 'B') {
            ordersInfo.destination_name = ordersInfo.warehouse_address
          }
          let paramUpdate = {
            orders_id: this.ordersID,
            information: ordersInfo,
            details: this.ordersDetails
          }
          let updateOrder = await this.$http.post(this.$api_url.reserves_update, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(updateOrder.data)
          console.log('SingleReserveOrders:updateReserves: ', $data)
          if ($data.success === true) {
            this.$toastr.success(successMessage, this.translations('common.success'))
            this.ordersInfo = JSON.parse(JSON.stringify(ordersInfo))
            await this.$http.post(this.$api_url.orders_detail, { orders_id: this.tempInfo.parent_order_id })
            setTimeout(() => {
              location.reload()
            }, '500')
          } else {
            if (updateOrder.data.warning) {
              this.$toastr.warning(this.translations('reserve.' + updateOrder.data.message))
            } else {
              this.$toastr.error($data.data, this.translations('common.error'))
            }
          }
          this.isLoading = false
          this.allChecked = false
        } catch (error) {
          this.isLoading = false
          this.allChecked = false
          console.log('SingleOrders:updateReserves:catch(error): ', error)
          this.$toastr.error(errorMessage + this.translations('reserve.notice_check_error'), this.translations('common.error'))
        }
      })
    },

    deleteReserves () {
      this.$dialog.confirm(this.translations('reserve.delete_reserve'), {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          this.isLoading = true
          try {
            const response = await this.$http.post(this.$api_url.reserves_delete, { orders_id: this.ordersID })
            const result = response.data
            if (result.status === true) {
              this.$toastr.success(this.translations('reserve.notice_deleted_reserve'), this.translations('common.success'))
              await this.$http.post(this.$api_url.orders_detail, { orders_id: this.tempInfo.parent_order_id })
              this.$router.replace('archive-reserves')
              setTimeout(() => { this.isLoading = false }, 1000)
            } else {
              this.$toastr.warning(result.message)
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SingleReserves:deleOrders:catch(error): ', error)
            this.$toastr.error(this.translations('reserve.notice_deleted_reserve_fail'), this.translations('common.error'))
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    },

    requestApprove () {
      this.updateReserves(UPDATE_TYPE_REQUEST_APPROVE)
    },

    approve (user) {
      this.updateReserves(UPDATE_TYPE_APPROVE, user)
    },

    isUserApproved (user) {
      console.log(user)
      const approvers = JSON.parse(this.ordersInfo.approvers)
      console.log(approvers)
      return approvers.indexOf(user.id) >= 0
    },

    isApproveRole (user) {
      return user.id === this.$store.getters['User/id']
    },

    onChangeUnitPrice (detail) {
      if (Number(detail.tax_status) === 1) {
        if (Number(detail.taxclass_id) === 1) {
          detail.unit_price_inctax = this.$util.getIncludeTax(detail.unit_price, Number(detail.tax_rate || this.taxRate))
        } else {
          detail.unit_price_inctax = detail.unit_price
        }
      } else {
        if (Number(detail.taxclass_id) === 1) {
          detail.unit_price = this.$util.getExcludeTax(detail.unit_price_inctax, Number(detail.tax_rate || this.taxRate))
        } else {
          detail.unit_price = detail.unit_price_inctax
        }
      }
    },

    moveOn () {
      if (this.afterId) {
        // $router.pushだとcreatedが走らないため
        location.href = `/single-reserves?orders_id=${this.afterId}`
      }
    },

    returnOn () {
      if (this.beforeId) {
        // $router.pushだとcreatedが走らないため
        location.href = `/single-reserves?orders_id=${this.beforeId}`
      }
    },

    getStatusClass (status) {
      if (Number(status) === OrderStatus.SHIPPED) {
        return 'badge-success'
      } else if (Number(status) === OrderStatus.NOT_RESERVED) {
        return 'badge-light'
      } else if (Number(status) === OrderStatus.RESERVE_COMPLETED) {
        return 'badge-dark'
      } else if (Number(status) === OrderStatus.PARTIAL_RESERVE) {
        return 'badge-warning'
      }
      return 'badge-warning'
    },

    getStatusLabel (status) {
      if (Number(status) === OrderStatus.SHIPPED) {
        return this.translations('reserve.shipped')
      } else if (Number(status) === OrderStatus.NOT_RESERVED) {
        return this.translations('reserve.unreserved')
      } else if (Number(status) === OrderStatus.RESERVE_COMPLETED) {
        return this.translations('reserve.reserve_completed')
      } else if (Number(status) === OrderStatus.PARTIAL_RESERVE) {
        return this.translations('reserve.partial_shipment')
      }
      return this.translations('reserve.reserve_completed_partial')
    },

    async getEmployeeByCompany () {
      this.isLoading = true
      try {
        const { data: { data, status } } = await this.$http.post(this.$api_url.employee_by_company, { company_id: this.tempInfo.client_id })
        if (status) {
          this.$set(this.tempInfo, 'end_user', data)
          this.updateField('end_user', data, 'info06')
        }
      } catch (error) {}
      this.isLoading = false
    },

    changeTempShipping () {
      if (this.isTempShipping) {
        this.tempInfo.company_name_temp = this.tempInfo.company_name_temp || this.tempInfo.client_name
        this.tempInfo.suppliers_temp = this.tempInfo.suppliers_temp || UNIQ_ADDRESS
        this.tempInfo.destination_name_temp = this.tempInfo.destination_name_temp || this.tempInfo.destination_name
        this.tempInfo.note_temp = this.tempInfo.note_temp || this.tempInfo.memo
        this.tempInfo.remove_price_temp = Boolean(Number(this.tempInfo.remove_price_temp)) || false
      }
    },

    calculateRows (text) {
      return text ? text.split('\n').length : this.inputRows
    },

    moveToOrder () {
      let confirmMessage = this.translations('reserve.update_reserve')
      let successMessage = this.translations('reserve.notice_reserve_update_success')
      let errorMessage = this.translations('reserve.notice_reserve_update_fail')
      let indexCheck = []
      this.ordersDetails.findIndex(ordersDetail => {
        if (ordersDetail.check) {
          indexCheck.push(ordersDetail)
        }
      })

      if (indexCheck.length < 1) {
        return this.$toastr.warning(this.translations('reserve.notice_choice_product'))
      }
      this.$dialog.confirm(confirmMessage).then(async () => {
        try {
          this.isLoading = true
          let paramUpdate = {
            orders_id: this.ordersID,
            orders_detail: this.ordersDetails,
            reserve: true,
            all_check: this.ordersDetails.length === indexCheck.length
          }
          let $data = await this.$http.post(this.$api_url.order_move_reserve, paramUpdate)
          if ($data.data.status === true) {
            this.$toastr.success(successMessage, this.translations('common.success'))
            if (this.ordersDetails.length === indexCheck.length) {
              this.$router.replace('archive-reserves')
            }
            await this.$http.post(this.$api_url.orders_detail, { orders_id: this.tempInfo.parent_order_id })
            setTimeout(() => {
              location.reload()
            }, '500')
          } else {
            this.$toastr.error($data.data.message, this.translations('common.error'))
          }
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.$toastr.error(errorMessage + this.translations('reserve.notice_check_error'), this.translations('common.error'))
        }
      })
    },

    onChangeCheckedAll (e) {
      const setChildCheckBox = e.target.checked

      const ordersDetails = this.ordersDetails.map(function (orderDetail) {
        if (Number(orderDetail.reserved) !== 2) {
          orderDetail.check = setChildCheckBox
        }
        return orderDetail
      })
      this.ordersDetails = ordersDetails
      this.allChecked = this.ordersDetails
        .filter((orderDetail) => Number(orderDetail.reserved) !== 2)
        .every((orderDetail) => orderDetail.check)
    },

    onChangeInputChecked (e) {
      let id = parseInt(e.target.value)
      let ordersDetails = [...this.ordersDetails]
      let indexDetail = _.findIndex(this.ordersDetails, function (orderDetail) { return orderDetail.id === id })
      if (Number(ordersDetails[indexDetail].reserved) !== 2) {
        ordersDetails[indexDetail].check = !ordersDetails[indexDetail].check
      }

      this.ordersDetails = ordersDetails
      const checkAllInputChecked = ordersDetails.filter((orderDetail) => Number(orderDetail.reserved) !== 2).every((orderDetail) => orderDetail.check)
      this.allChecked = checkAllInputChecked
    },

    openSingleReserveProcessModal () {
      this.reserveDetails = []
      this.ordersDetails.findIndex(ordersDetail => {
        if (ordersDetail.check) {
          this.reserveDetails.push(ordersDetail.id)
        }
      })

      if (this.reserveDetails.length < 1) {
        return this.$toastr.warning(this.translations('reserve.notice_select_one_product'))
      }
      let checkQuantityReserved = this.ordersDetails.some(product => product.total_quantity_reserved > 0 && product.check)

      if (checkQuantityReserved) {
        return this.$toastr.warning(this.translations('reserve.notice_quantity_process_reserve'))
      }

      this.shippingReserve = false
      this.$refs.openSingleReserveProcessModal.click()
    },

    openSingleReservesModal () {
      this.shippingReserve = true
      this.$refs.openSingleReservesModal.click()
    }
  }
}
</script>

<style>
[for='checkBox'] {
  margin-top: 7px;
  margin-right: 0.6rem;
}
</style>

<style scoped>
.btn-memo-internal {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.min-height-120 {
  min-height: 120px;
}

textarea {
  resize: both;
}
</style>
